export default "__VITE_ASSET__CR$pZHXm__"